(() => {
  if (window.TudiRepCatalogRuntimeLoaded) return;
  window.TudiRepCatalogRuntimeLoaded = true;

  const SELECTORS = {
    root: '[data-tudi-rep-catalog]',
    sets: '[data-tudi-rep-sets]',
    grid: '[data-tudi-rep-grid]',
    search: '[data-tudi-rep-search]',
    summary: '[data-tudi-rep-summary]',
    status: '[data-tudi-rep-status]',
    setTitle: '[data-tudi-rep-set-title]',
    setKicker: '[data-tudi-rep-set-kicker]',
    cartbar: '[data-tudi-rep-cartbar]',
    selectedCount: '[data-tudi-rep-selected-count]',
    selectedUnits: '[data-tudi-rep-selected-units]',
    addSelected: '[data-tudi-rep-add-selected]',
    viewCart: '[data-tudi-rep-view-cart]',
    clear: '[data-tudi-rep-clear]',
    modal: '[data-tudi-rep-modal]',
    modalBody: '[data-tudi-rep-modal-body]',
    printButtons: '[data-tudi-rep-print]',
    printArea: '[data-tudi-rep-print-area]'
  };

  const productCache = new Map();

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTORS.root).forEach(initCatalog);
  }

  function initCatalog(root) {
    if (root.dataset.tudiRepReady === 'true') return;
    root.dataset.tudiRepReady = 'true';

    const data = window.TUDI_REP_CATALOG_DATA || { items: [], groups: 0, excluded: [] };
    const items = Array.isArray(data.items) ? data.items : [];
    const groups = groupItems(items);

    const state = {
      currentGroup: groups[0]?.group || 1,
      query: '',
      selected: new Map(),
      isAdding: false
    };

    const els = {
      sets: Array.from(root.querySelectorAll(SELECTORS.sets)),
      grid: root.querySelector(SELECTORS.grid),
      search: root.querySelector(SELECTORS.search),
      summary: root.querySelector(SELECTORS.summary),
      status: root.querySelector(SELECTORS.status),
      setTitle: root.querySelector(SELECTORS.setTitle),
      setKicker: root.querySelector(SELECTORS.setKicker),
      cartbar: root.querySelector(SELECTORS.cartbar),
      selectedCount: root.querySelector(SELECTORS.selectedCount),
      selectedUnits: root.querySelector(SELECTORS.selectedUnits),
      addSelected: root.querySelector(SELECTORS.addSelected),
      viewCart: root.querySelector(SELECTORS.viewCart),
      clear: root.querySelector(SELECTORS.clear),
      modal: root.querySelector(SELECTORS.modal),
      modalBody: root.querySelector(SELECTORS.modalBody),
      printButtons: Array.from(root.querySelectorAll(SELECTORS.printButtons)),
      printArea: root.querySelector(SELECTORS.printArea)
    };

    renderSummary(els.summary, data);
    renderSetNav(els.sets, groups, state, () => render(root, els, groups, state));
    render(root, els, groups, state);

    els.search?.addEventListener('input', event => {
      state.query = event.target.value.trim().toLowerCase();
      render(root, els, groups, state);
    });

    els.addSelected?.addEventListener('click', () => addSelectedToCart(root, els, state));
    els.printButtons.forEach(button => {
      button.addEventListener('click', () => printCatalog(root, els, groups, button.dataset.printMode || 'clickable'));
    });
    els.viewCart?.addEventListener('click', () => {
      window.location.href = root.dataset.cartUrl || '/cart';
    });
    els.clear?.addEventListener('click', () => {
      state.selected.clear();
      root.querySelectorAll('[data-tudi-rep-qty]').forEach(input => {
        input.value = '0';
      });
      updateCartbar(els, state);
      setStatus(els.status, 'Quantities cleared.', '');
    });

    root.querySelectorAll('[data-tudi-rep-modal-close]').forEach(button => {
      button.addEventListener('click', () => closeModal(els.modal));
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !els.modal.hidden) {
        closeModal(els.modal);
      }
    });
  }

  function groupItems(items) {
    const map = new Map();
    items.forEach(item => {
      const groupNo = Number(item.group) || 1;
      if (!map.has(groupNo)) map.set(groupNo, []);
      map.get(groupNo).push(item);
    });

    return Array.from(map.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([group, groupItems]) => ({
        group,
        title: `Set ${group}`,
        items: groupItems.slice().sort((a, b) => (Number(a.slot) || 0) - (Number(b.slot) || 0))
      }));
  }

  function renderSummary(summaryEl, data) {
    if (!summaryEl) return;
    const groupText = Number(data.groups) === 1 ? '1 set' : `${data.groups || 0} sets`;
    summaryEl.textContent = `${data.validItemCount || 0} wraps · ${groupText}`;
  }

  function renderSetNav(containers, groups, state, onChange) {
    const navs = normalizeSetNavContainers(containers);
    if (!navs.length) return;

    navs.forEach(container => {
      container.innerHTML = '';
      groups.forEach(group => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tudi-rep-catalog__set-button';
        button.textContent = `${group.title} (${group.items.length})`;
        button.dataset.group = String(group.group);
        button.setAttribute('aria-pressed', group.group === state.currentGroup ? 'true' : 'false');
        if (group.group === state.currentGroup) button.classList.add('is-active');
        button.addEventListener('click', () => {
          state.currentGroup = group.group;
          state.query = '';
          const root = container.closest(SELECTORS.root);
          const search = root?.querySelector(SELECTORS.search);
          if (search) search.value = '';
          onChange();

          if (container.hasAttribute('data-tudi-rep-sets-bottom')) {
            root?.querySelector(SELECTORS.setTitle)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
        container.appendChild(button);
      });
    });
  }

  function render(root, els, groups, state) {
    const activeGroup = groups.find(group => group.group === state.currentGroup) || groups[0];
    const allItems = groups.flatMap(group => group.items);
    const isSearch = state.query.length > 0;
    const visibleItems = isSearch ? filterItems(allItems, state.query) : (activeGroup?.items || []);

    if (els.setTitle) {
      els.setTitle.textContent = isSearch ? `Search results (${visibleItems.length})` : `${activeGroup.title} · ${activeGroup.items.length} wraps`;
    }
    if (els.setKicker) {
      els.setKicker.textContent = isSearch ? 'Matching title or SKU' : 'Group of 20';
    }

    renderSetButtons(els.sets, state.currentGroup);
    renderGrid(root, els.grid, visibleItems, state);
    updateCartbar(els, state);
  }

  function filterItems(items, query) {
    return items.filter(item => {
      const haystack = `${item.title || ''} ${item.sku || ''} ${item.handle || ''}`.toLowerCase();
      return haystack.includes(query);
    });
  }

  function renderSetButtons(containers, currentGroup) {
    normalizeSetNavContainers(containers).forEach(container => {
      container.querySelectorAll('[data-group]').forEach(button => {
        const isActive = Number(button.dataset.group) === Number(currentGroup);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  }

  function normalizeSetNavContainers(containers) {
    if (!containers) return [];
    if (Array.isArray(containers)) return containers.filter(Boolean);
    if (typeof containers.forEach === 'function' && typeof containers.length === 'number') {
      return Array.from(containers).filter(Boolean);
    }
    return [containers].filter(Boolean);
  }

  function renderGrid(root, grid, items, state) {
    if (!grid) return;
    grid.innerHTML = '';

    if (!items.length) {
      const empty = document.createElement('div');
      empty.className = 'tudi-rep-empty';
      empty.textContent = 'No wraps found.';
      grid.appendChild(empty);
      return;
    }

    items.forEach(item => {
      grid.appendChild(createCard(root, item, state));
    });
  }

  function createCard(root, item, state) {
    const card = document.createElement('article');
    card.className = 'tudi-rep-card';
    card.dataset.handle = item.handle;

    const selectedQty = state.selected.get(item.id)?.quantity || 0;
    const showPrice = root.dataset.showPrice !== 'false';

    card.innerHTML = `
      <span class="tudi-rep-card__slot">${escapeHtml(item.slot)}</span>
      <button type="button" class="tudi-rep-card__media-button" data-action="details" aria-label="View ${escapeHtml(item.title)}">
        <span class="tudi-rep-card__media">
          <img src="${escapeAttr(item.image)}" alt="${escapeAttr(item.title)}" loading="lazy" width="480" height="480">
        </span>
      </button>
      <div class="tudi-rep-card__body">
        <h3 class="tudi-rep-card__title">${escapeHtml(item.title)}</h3>
        <div class="tudi-rep-card__meta">
          ${showPrice ? `<span class="tudi-rep-card__pill">${formatExcelPrice(item.price)}</span>` : ''}
        </div>
      </div>
      <div class="tudi-rep-card__actions">
        <div class="tudi-rep-card__qty">
          <label for="TudiQty-${escapeAttr(item.id)}">Qty</label>
          <input id="TudiQty-${escapeAttr(item.id)}" data-tudi-rep-qty type="number" inputmode="numeric" min="0" max="999" step="1" value="${selectedQty}">
        </div>
        <button type="button" class="tudi-rep-card__detail" data-action="details">Details</button>
      </div>
    `;

    card.querySelectorAll('[data-action="details"]').forEach(button => {
      button.addEventListener('click', () => openDetails(root, item, state));
    });

    const qtyInput = card.querySelector('[data-tudi-rep-qty]');
    qtyInput.addEventListener('input', () => {
      const quantity = sanitizeQuantity(qtyInput.value);
      qtyInput.value = quantity ? String(quantity) : '0';
      if (quantity > 0) {
        state.selected.set(item.id, { item, quantity });
      } else {
        state.selected.delete(item.id);
      }
      const els = getEls(root);
      updateCartbar(els, state);
    });

    hydrateCardImageFromShopify(root, item, card);

    return card;
  }

  async function hydrateCardImageFromShopify(root, item, card) {
    if (!root || !item?.handle || !card) return;

    const image = card.querySelector('.tudi-rep-card__media img');
    if (!image) return;

    try {
      const product = await fetchProduct(root, item.handle);
      const shopifyImage = getProductImage(product);
      if (!shopifyImage || card.dataset.handle !== item.handle) return;

      image.src = shopifyImage;
      image.removeAttribute('srcset');
      image.dataset.source = 'shopify-product';
    } catch (_error) {
      image.dataset.source = 'excel-fallback';
    }
  }

  function getProductImage(product) {
    const candidates = [
      product?.featured_image,
      Array.isArray(product?.images) ? product.images[0] : null,
      product?.image,
      Array.isArray(product?.media) ? product.media.find(media => media?.media_type === 'image') : null
    ];

    for (const candidate of candidates) {
      const image = normalizeProductImage(candidate);
      if (image) return image;
    }

    return '';
  }

  function normalizeProductImage(candidate) {
    if (!candidate) return '';
    if (typeof candidate === 'string') return candidate;
    return candidate.src || candidate.url || candidate.preview_image?.src || candidate.image?.src || '';
  }

  function getEls(root) {
    return {
      status: root.querySelector(SELECTORS.status),
      cartbar: root.querySelector(SELECTORS.cartbar),
      selectedCount: root.querySelector(SELECTORS.selectedCount),
      selectedUnits: root.querySelector(SELECTORS.selectedUnits),
      addSelected: root.querySelector(SELECTORS.addSelected),
      viewCart: root.querySelector(SELECTORS.viewCart),
      clear: root.querySelector(SELECTORS.clear),
      modal: root.querySelector(SELECTORS.modal),
      modalBody: root.querySelector(SELECTORS.modalBody),
      printArea: root.querySelector(SELECTORS.printArea)
    };
  }

  function updateCartbar(els, state) {
    const lines = Array.from(state.selected.values());
    const itemCount = lines.length;
    const unitCount = lines.reduce((sum, line) => sum + line.quantity, 0);

    if (els.cartbar) els.cartbar.hidden = itemCount === 0;
    if (els.clear) els.clear.hidden = itemCount === 0;
    if (els.selectedCount) els.selectedCount.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'} selected`;
    if (els.selectedUnits) els.selectedUnits.textContent = `${unitCount} ${unitCount === 1 ? 'unit' : 'units'}`;
    if (els.addSelected) els.addSelected.disabled = itemCount === 0 || state.isAdding;
  }

  async function openDetails(root, item, state) {
    const els = getEls(root);
    const selectedQty = state.selected.get(item.id)?.quantity || 1;
    openModal(els.modal);
    els.modalBody.innerHTML = '<p>Loading product...</p>';

    let product = null;
    let fetchError = '';
    try {
      product = await fetchProduct(root, item.handle);
    } catch (error) {
      fetchError = error.message || 'Product could not be loaded.';
    }

    const fallbackImage = item.image;
    const image = getProductImage(product) || fallbackImage;
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const catalogVariants = getRepCatalogVariants(variants, item);
    const defaultVariant = chooseVariant(variants, item);
    const hasVariants = catalogVariants.length > 1;
    const noCatalogVariantMessage = product && !defaultVariant
      ? 'No Regular/Small variant is available for this catalog item. Large variants are excluded from the rep catalog.'
      : '';
    const description = product?.description ? stripScripts(product.description) : '';
    const productUrl = getProductUrl(root, item);

    els.modalBody.innerHTML = `
      <div class="tudi-rep-modal__content">
        <div class="tudi-rep-modal__image">
          <img src="${escapeAttr(image)}" alt="${escapeAttr(item.title)}">
        </div>
        <div class="tudi-rep-modal__info">
          <h2 id="${escapeAttr('TudiRepModalTitle-' + item.id)}">${escapeHtml(product?.title || item.title)}</h2>
          <div class="tudi-rep-modal__meta">
            <span>SKU: ${escapeHtml(defaultVariant?.sku || item.sku)}</span>
            <span>Set ${escapeHtml(item.group)} · Slot ${escapeHtml(item.slot)}</span>
            <span>${escapeHtml(product ? formatVariantPrice(defaultVariant) : formatExcelPrice(item.price))}</span>
          </div>
          ${fetchError ? `<p class="tudi-rep-catalog__status is-error">${escapeHtml(fetchError)}</p>` : ''}
          ${noCatalogVariantMessage ? `<p class="tudi-rep-catalog__status is-error">${escapeHtml(noCatalogVariantMessage)}</p>` : ''}
          ${hasVariants ? `
            <div class="tudi-rep-modal__field">
              <label for="TudiRepVariant-${escapeAttr(item.id)}">Variant</label>
              <select class="tudi-rep-modal__variant" id="TudiRepVariant-${escapeAttr(item.id)}" data-tudi-rep-modal-variant>
                ${catalogVariants.map(variant => `
                  <option value="${escapeAttr(variant.id)}" ${variant.id === defaultVariant?.id ? 'selected' : ''}>
                    ${escapeHtml(variant.title)}${variant.sku ? ` · ${escapeHtml(variant.sku)}` : ''}
                  </option>
                `).join('')}
              </select>
              <p class="tudi-rep-modal__hint">Rep catalog uses Regular/Small variants only. Large variants are excluded.</p>
            </div>
          ` : ''}
          <div class="tudi-rep-modal__field tudi-rep-modal__qty">
            <label for="TudiRepModalQty-${escapeAttr(item.id)}">Quantity</label>
            <input id="TudiRepModalQty-${escapeAttr(item.id)}" type="number" min="1" max="999" step="1" value="${selectedQty || 1}" data-tudi-rep-modal-qty>
          </div>
          <div class="tudi-rep-modal__url">
            <label for="TudiRepProductUrl-${escapeAttr(item.id)}">Product URL</label>
            <div class="tudi-rep-modal__url-row">
              <input id="TudiRepProductUrl-${escapeAttr(item.id)}" type="text" readonly value="${escapeAttr(productUrl)}" data-tudi-rep-product-url>
              <button type="button" class="button button--secondary" data-tudi-rep-copy-url>Copy URL</button>
            </div>
          </div>
          <div class="tudi-rep-modal__actions">
            <button type="button" class="button" data-tudi-rep-modal-add ${product && defaultVariant ? '' : 'disabled'}>Add this item to cart</button>
            <button type="button" class="button button--secondary" data-tudi-rep-modal-select>Save quantity</button>
            <a class="button button--secondary tudi-rep-modal__open-link" href="${escapeAttr(productUrl)}" target="_blank" rel="noopener">Open Product Page</a>
          </div>
          ${description ? `<div class="tudi-rep-modal__description rte">${description}</div>` : ''}
        </div>
      </div>
    `;

    const qtyInput = els.modalBody.querySelector('[data-tudi-rep-modal-qty]');
    const variantSelect = els.modalBody.querySelector('[data-tudi-rep-modal-variant]');
    const selectButton = els.modalBody.querySelector('[data-tudi-rep-modal-select]');
    const addButton = els.modalBody.querySelector('[data-tudi-rep-modal-add]');
    const copyButton = els.modalBody.querySelector('[data-tudi-rep-copy-url]');
    const productUrlInput = els.modalBody.querySelector('[data-tudi-rep-product-url]');

    copyButton?.addEventListener('click', async () => {
      const copied = await copyText(productUrl, productUrlInput);
      copyButton.textContent = copied ? 'Copied' : 'Select URL';
      window.setTimeout(() => {
        copyButton.textContent = 'Copy URL';
      }, 1400);
    });

    selectButton?.addEventListener('click', () => {
      const quantity = Math.max(1, sanitizeQuantity(qtyInput.value));
      state.selected.set(item.id, { item, quantity });
      syncCardQuantity(root, item.id, quantity);
      updateCartbar(getEls(root), state);
      closeModal(els.modal);
      setStatus(getEls(root).status, `${item.title} quantity saved.`, 'success');
    });

    addButton?.addEventListener('click', async () => {
      if (!product) return;
      const quantity = Math.max(1, sanitizeQuantity(qtyInput.value));
      const variantId = variantSelect?.value ? Number(variantSelect.value) : defaultVariant?.id;
      if (!variantId) {
        setStatus(getEls(root).status, `No sellable variant found for ${item.title}.`, 'error');
        return;
      }
      addButton.disabled = true;
      addButton.textContent = 'Adding...';
      try {
        await postCartItems(root, [{ id: variantId, quantity }]);
        setStatus(getEls(root).status, `${quantity} unit${quantity === 1 ? '' : 's'} of ${item.title} added to cart.`, 'success');
        const viewCart = root.querySelector(SELECTORS.viewCart);
        if (viewCart) viewCart.hidden = false;
        closeModal(els.modal);
      } catch (error) {
        setStatus(getEls(root).status, error.message || 'Could not add item to cart.', 'error');
        addButton.disabled = false;
        addButton.textContent = 'Add this item to cart';
      }
    });
  }

  async function printCatalog(root, els, groups, mode) {
    if (!els.printArea) return;

    const printMode = mode === 'plain' ? 'plain' : 'clickable';
    els.printArea.innerHTML = buildPrintCatalogHtml(root, groups, printMode);
    els.printArea.hidden = false;
    els.printArea.setAttribute('aria-hidden', 'false');
    root.dataset.tudiRepPrintMode = printMode;
    document.body.classList.add('tudi-rep-print-active');
    setStatus(els.status, printMode === 'clickable'
      ? 'Preparing clickable PDF catalog...'
      : 'Preparing PDF catalog without links...', '');

    const printButtons = Array.from(root.querySelectorAll(SELECTORS.printButtons));
    printButtons.forEach(button => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });

    const cleanup = () => {
      document.body.classList.remove('tudi-rep-print-active');
      delete root.dataset.tudiRepPrintMode;
      printButtons.forEach(button => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
      if (els.printArea) {
        els.printArea.hidden = true;
        els.printArea.setAttribute('aria-hidden', 'true');
        els.printArea.innerHTML = '';
      }
      setStatus(els.status, 'PDF print view closed.', 'success');
      window.removeEventListener('afterprint', cleanup);
    };

    window.addEventListener('afterprint', cleanup, { once: true });

    try {
      const preload = await waitForPrintImages(els.printArea, (loaded, total) => {
        if (total > 0) {
          setStatus(els.status, `Preparing PDF images... ${loaded}/${total}`, '');
        }
      });

      if (preload.timedOut) {
        setStatus(els.status, `PDF images still loading (${preload.loaded}/${preload.total}). Opening print anyway.`, '');
      } else {
        setStatus(els.status, printMode === 'clickable'
          ? 'Clickable PDF catalog ready. Opening print dialog...'
          : 'PDF catalog without links ready. Opening print dialog...', '');
      }

      await nextFrame();
      await nextFrame();
      window.print();
    } catch (error) {
      setStatus(els.status, error?.message || 'Opening print dialog...', '');
      window.print();
    }
  }

  function waitForPrintImages(container, onProgress, timeoutMs = 12000) {
    const images = Array.from(container?.querySelectorAll('img') || []);
    const total = images.length;
    let loaded = 0;

    if (!total) {
      if (typeof onProgress === 'function') onProgress(0, 0);
      return Promise.resolve({ loaded: 0, total: 0, timedOut: false });
    }

    if (typeof onProgress === 'function') onProgress(0, total);

    const imagePromises = images.map(image => new Promise(resolve => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        image.removeEventListener('load', finish);
        image.removeEventListener('error', finish);
        loaded += 1;
        if (typeof onProgress === 'function') onProgress(loaded, total);
        resolve();
      };

      if (image.complete) {
        finish();
        return;
      }

      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });

      if (typeof image.decode === 'function') {
        image.decode().then(finish).catch(() => {});
      }
    }));

    const allLoaded = Promise.all(imagePromises).then(() => ({ loaded, total, timedOut: false }));
    const timeout = new Promise(resolve => {
      window.setTimeout(() => resolve({ loaded, total, timedOut: true }), timeoutMs);
    });

    return Promise.race([allLoaded, timeout]);
  }

  function nextFrame() {
    return new Promise(resolve => window.requestAnimationFrame(resolve));
  }

  function buildPrintCatalogHtml(root, groups, mode) {
    const clickable = mode === 'clickable';
    const totalItems = groups.reduce((sum, group) => sum + group.items.length, 0);
    const modeLabel = clickable ? 'Clickable product links' : 'No product links';

    return `
      <div class="tudi-rep-print__document" data-print-mode="${escapeAttr(mode)}">
        ${groups.map(group => `
          <section class="tudi-rep-print__page">
            <header class="tudi-rep-print__header">
              <div>
                <p class="tudi-rep-print__eyebrow">TUDI Wrap Catalog</p>
                <h2>Set ${escapeHtml(group.group)}</h2>
              </div>
              <div class="tudi-rep-print__summary">
                <span>${escapeHtml(group.items.length)} wraps</span>
                <span>${escapeHtml(modeLabel)}</span>
                <span>${escapeHtml(totalItems)} total</span>
              </div>
            </header>
            <div class="tudi-rep-print__grid">
              ${group.items.map(item => buildPrintCardHtml(root, item, clickable)).join('')}
            </div>
          </section>
        `).join('')}
      </div>
    `;
  }

  function buildPrintCardHtml(root, item, clickable) {
    const productUrl = getProductUrl(root, item);
    const cachedProduct = productCache.get(item.handle);
    const image = getProductImage(cachedProduct) || item.image;
    const cardInner = `
      <span class="tudi-rep-print__slot">${escapeHtml(item.slot)}</span>
      <span class="tudi-rep-print__media">
        <img src="${escapeAttr(image)}" alt="${escapeAttr(item.title)}" loading="eager" decoding="sync">
      </span>
      <span class="tudi-rep-print__body">
        <strong>${escapeHtml(item.title)}</strong>
        <span>${formatExcelPrice(item.price)}</span>
      </span>
    `;

    if (clickable) {
      return `
        <a class="tudi-rep-print__card tudi-rep-print__card--link" href="${escapeAttr(productUrl)}" target="_blank" rel="noopener">
          ${cardInner}
        </a>
      `;
    }

    return `
      <div class="tudi-rep-print__card" aria-label="${escapeAttr(item.title)}">
        ${cardInner}
      </div>
    `;
  }

  function getProductUrl(root, item) {
    const handle = String(item?.handle || '').trim();
    const configuredBase = String(root?.dataset.productBaseUrl || 'https://tudiwrap.com').trim() || 'https://tudiwrap.com';
    const cleanBase = configuredBase.replace(/\/+$/, '');
    const productPath = `/products/${encodeURIComponent(handle)}`;

    try {
      return new URL(productPath, `${cleanBase}/`).href;
    } catch (_error) {
      return `https://tudiwrap.com${productPath}`;
    }
  }

  async function copyText(text, input) {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (_error) {}

    if (input) {
      input.focus();
      input.select();
      return false;
    }

    return false;
  }

  function syncCardQuantity(root, itemId, quantity) {
    const input = root.querySelector(`#TudiQty-${cssEscape(itemId)}`);
    if (input) input.value = String(quantity);
  }

  async function addSelectedToCart(root, els, state) {
    const selected = Array.from(state.selected.values());
    if (!selected.length || state.isAdding) return;

    state.isAdding = true;
    els.addSelected.disabled = true;
    els.addSelected.textContent = 'Adding...';
    setStatus(els.status, 'Preparing selected wraps...', '');

    try {
      const prepared = await Promise.all(selected.map(async line => {
        const product = await fetchProduct(root, line.item.handle);
        const variant = chooseVariant(product.variants || [], line.item);
        if (!variant?.id) {
          throw new Error(`No variant found for ${line.item.title}.`);
        }
        if (variant.available === false) {
          throw new Error(`${line.item.title} is sold out.`);
        }
        return { id: variant.id, quantity: line.quantity };
      }));

      await postCartItems(root, prepared);
      const unitCount = selected.reduce((sum, line) => sum + line.quantity, 0);
      setStatus(els.status, `${selected.length} item${selected.length === 1 ? '' : 's'} / ${unitCount} unit${unitCount === 1 ? '' : 's'} added to cart.`, 'success');
      if (els.viewCart) els.viewCart.hidden = false;
      state.selected.clear();
      root.querySelectorAll('[data-tudi-rep-qty]').forEach(input => {
        input.value = '0';
      });
      updateCartbar(els, state);
      document.dispatchEvent(new CustomEvent('tudi:rep-catalog:cart-updated'));
    } catch (error) {
      setStatus(els.status, error.message || 'Could not add selected items to cart.', 'error');
    } finally {
      state.isAdding = false;
      els.addSelected.textContent = 'Add selected to cart';
      updateCartbar(els, state);
    }
  }

  async function fetchProduct(root, handle) {
    if (!handle) throw new Error('Product handle is missing.');
    if (productCache.has(handle)) return productCache.get(handle);

    const rootUrl = normalizeRoot(root.dataset.rootUrl || '/');
    const url = `${rootUrl}products/${encodeURIComponent(handle)}.js`;
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) {
      throw new Error(`Product data could not be loaded for ${handle}.`);
    }
    const product = await response.json();
    productCache.set(handle, product);
    return product;
  }

  async function postCartItems(root, items) {
    const cartAddUrl = getCartAddUrl(root);
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      let message = 'Shopify could not add the selected item(s) to cart.';
      try {
        const error = await response.json();
        message = error.description || error.message || message;
      } catch (_error) {}
      throw new Error(message);
    }

    return response.json();
  }

  function chooseVariant(variants, item) {
    const eligible = getRepCatalogVariants(variants, item);
    if (!eligible.length) return null;

    const sku = String(item.sku || '').trim().toLowerCase();
    const availableSkuMatch = eligible.find(variant => String(variant.sku || '').trim().toLowerCase() === sku);
    if (availableSkuMatch) return availableSkuMatch;

    const regularSmallMatch = eligible.find(isRegularOrSmallVariant);
    if (regularSmallMatch) return regularSmallMatch;

    return eligible[0];
  }

  function getRepCatalogVariants(variants, item) {
    if (!Array.isArray(variants) || !variants.length) return [];
    return variants.filter(variant => variant.available !== false && !isLargeVariant(variant, item));
  }

  function isRegularOrSmallVariant(variant) {
    const text = getVariantSearchText(variant);
    const sku = String(variant?.sku || '').trim().toLowerCase();
    return /(^|[\s_\-/])(reg|regular|small|sm|standard|std)(?=$|[\s_\-/])/.test(text)
      || /[0-9](r|s)$/.test(sku)
      || /-(r|s)$/.test(sku);
  }

  function isLargeVariant(variant) {
    const text = getVariantSearchText(variant);
    const sku = String(variant?.sku || '').trim().toLowerCase();
    return /(^|[\s_\-/])(large|lg)(?=$|[\s_\-/])/.test(text)
      || /[0-9]l$/.test(sku)
      || /-l$/.test(sku);
  }

  function getVariantSearchText(variant) {
    return [
      variant?.title,
      variant?.public_title,
      variant?.name,
      variant?.sku,
      variant?.option1,
      variant?.option2,
      variant?.option3
    ].filter(Boolean).join(' ').toLowerCase();
  }

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function setStatus(statusEl, message, type) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    statusEl.classList.toggle('is-error', type === 'error');
    statusEl.classList.toggle('is-success', type === 'success');
  }

  function sanitizeQuantity(value) {
    const number = Number.parseInt(value, 10);
    if (!Number.isFinite(number) || number < 1) return 0;
    return Math.min(number, 999);
  }

  function formatExcelPrice(price) {
    if (price === null || price === undefined || price === '') return 'Price varies';
    const raw = String(price).trim();
    if (!raw) return 'Price varies';
    if (raw.includes('-')) {
      return raw.split('-').map(part => formatMoneyText(part)).join(' - ');
    }
    return formatMoneyText(raw);
  }

  function formatMoneyText(value) {
    const number = Number.parseFloat(String(value).replace(/[^0-9.]/g, ''));
    if (!Number.isFinite(number)) return String(value);
    return `$${number.toFixed(2)}`;
  }

  function formatVariantPrice(variant) {
    if (!variant || variant.price === undefined || variant.price === null) return 'Price varies';
    const cents = Number(variant.price);
    if (!Number.isFinite(cents)) return 'Price varies';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getCartAddUrl(root) {
    const rootUrl = normalizeRoot(root.dataset.rootUrl || '/');
    const configuredUrl = String(root.dataset.cartAddUrl || '').trim();
    if (!configuredUrl) return `${rootUrl}cart/add.js`;
    if (configuredUrl.includes('/cart/add.js')) return configuredUrl;
    if (configuredUrl.includes('/cart/add')) return configuredUrl.replace('/cart/add', '/cart/add.js');
    return `${rootUrl}cart/add.js`;
  }

  function normalizeRoot(rootUrl) {
    if (!rootUrl) return '/';
    return rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#096;');
  }

  function stripScripts(html) {
    const template = document.createElement('template');
    template.innerHTML = html;
    template.content.querySelectorAll('script, style').forEach(node => node.remove());
    return template.innerHTML;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
